







































import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import VueSimpleSuggest from 'vue-simple-suggest'
import { Worker } from '@/types/user'

type WorkerListItem = {
  name: string
  nameReading: string
  id: number
}

@Component({
  components: { VueSimpleSuggest }
})
export default class InviteWorkerSearchField extends Vue {
  @Prop() patientId?: number
  $store!: ExStore
  controls = {
    selectionUp: [38],
    selectionDown: [40],
    select: [],
    showList: [40],
    hideList: [27],
    autocomplete: [32, 13]
  }
  $refs!: {
    searchField: typeof VueSimpleSuggest
  }
  stopAutoSearch = false
  searchWord = ''

  @Emit('select')
  onSelect(worker: WorkerListItem | null) {
    return worker ? worker.id : null
  }

  @Emit('change')
  onChangeInputText(text: string) {
    return text
  }

  created() {
    this.getWorkerList()
  }

  get calendarSetting() {
    return this.$store.getters['schedule/calendar']
  }

  async getWorkerList() {
    try {
      const patients = await this.$api.team.fetch()
      const teamWorkers =
        patients.find(p => p.id === this.patientId)?.workers.map(w => w.id) ||
        []
      const allWorkers = patients
        .reduce((list, p) => [...list, ...p.workers], [] as Worker[])
        .filter(w => !teamWorkers.includes(w.id))
      const uniqueWorkerIds = Array.from(new Set(allWorkers.map(w => w.id)))
      const workers = uniqueWorkerIds.map(id =>
        allWorkers.find(w => w.id == id)
      )

      const list = workers.map(w => ({
        name: `${w?.lastName}${w?.firstName}`,
        nameReading: `${w?.lastNameReading} ${w?.firstNameReading}`,
        id: w?.id
      }))
      return list
    } catch (e) {
      console.log(e)
      return []
    }
  }

  onCloseClick() {
    this.$refs.searchField?.clearSuggestions()
    this.searchWord = ''
    this.onSelect(null)
  }

  onFocus() {
    this.$refs.searchField?.setText(' ')
  }

  async onChange(searchWord: string) {
    if (this.stopAutoSearch) {
      this.stopAutoSearch = false
      this.$refs.searchField?.hideList()
      return
    }
    this.searchWord = searchWord
    if (searchWord === '') this.$refs.searchField?.clearSuggestions()
    this.onChangeInputText(searchWord)
  }

  onSelectPatient(worker?: WorkerListItem) {
    this.stopAutoSearch = true
    worker ? this.onSelect(worker) : this.onSelect(null)
    this.$refs.searchField?.clearSuggestions()
    setTimeout(() => {
      this.$refs.searchField.setText(worker?.name)
      setTimeout(() => {
        this.onSelect(worker || null)
      }, 100)
    }, 100)
  }

  selectByEnter() {
    const data = this.$refs.searchField?.hovered
    if (!data) return
    this.stopAutoSearch = true
    this.$refs.searchField?.select(data)
    this.$refs.searchField?.clearSuggestions()
    this.onSelect(data)
  }

  filter(item: WorkerListItem, query: string) {
    return `${item.name} ${item.nameReading}`.indexOf(query) != -1
  }
}
